@if(tableIsLoading) {
<div class="component-spinner-box">
  <mat-spinner [diameter]="100"></mat-spinner>
</div>
}
<div class="table-container">
  <p-table [value]="auditDownloadList" [rows]="pageSize" [totalRecords]="lengthPage" dataKey="id" [paginator]="true"
    (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="reference">
          {{ 'report-audit.report-audit-download.column-table-reference' | translate }}
        </th>

        <th pSortableColumn="preSignedUrlMprev">MPREV</th>
        <th pSortableColumn="idAudit">SDFT</th>
        <th pSortableColumn="preSignedUrlSdot">SDOT</th>
        <th pSortableColumn="preSignedUrlIcti">ICTI</th>
        <th pSortableColumn="preSignedUrlIcvi">ICVI</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>

        <td>{{ row.reference }}</td>

        <!-- MPREV -->
        <td>

          @if (row.preSignedUrlMprev) {
          <a class="icon-action" (click)="downloadReportAudit(row.preSignedUrlMprev)">
            <i class="pi pi-download"></i>
          </a>
          }

          @if (!row.preSignedUrlMprev && isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-download" pTooltip="Arquivo expirado." tooltipPosition="top">
          </i>
          }

          @if (!row.preSignedUrlMprev && !isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-refresh icon-action" pTooltip="Refazer arquivo..." tooltipPosition="top"
            (click)="regeneratepreSignedUrlMprev(row.idAudit)">
          </i>
          }

        </td>

        <!-- SDFT -->
        <td>

          @if (row.idAudit) {
          <i class="pi pi-download icon-action" (click)="getAuditorshipInstallations(row.idAudit)">
          </i>
          }

          @if (!row.idAudit) {
          <i class="pi pi-download" pTooltip="Arquivo não gerado..." tooltipPosition="top">
          </i>
          }

        </td>

        <!-- SDOT -->
        <td>

          @if (row.preSignedUrlSdot) {
          <a class="icon-action" (click)="downloadReportAudit(row.preSignedUrlSdot)">
            <i class="pi pi-download"></i>
          </a>
          }

          @if (!row.preSignedUrlSdot && isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-download" pTooltip="Arquivo expirado." tooltipPosition="top">
          </i>
          }

          @if (!row.preSignedUrlSdot && !isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-refresh icon-action" pTooltip="Refazer arquivo..." tooltipPosition="top"
            (click)="regeneratepreSignedUrlSdot(row.idAudit)">
          </i>
          }

        </td>

        <!-- ICTI -->
        <td>

          @if (row.preSignedUrlIcti) {
          <a class="icon-action" (click)="downloadReportAudit(row.preSignedUrlIcti)">
            <i class="pi pi-download"></i>
          </a>
          }

          @if (!row.preSignedUrlIcti && isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-download" pTooltip="Arquivo expirado." tooltipPosition="top">
          </i>
          }

          @if (!row.preSignedUrlIcti && !isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-refresh icon-action" pTooltip="Refazer arquivo..." tooltipPosition="top"
            (click)="regeneratepreSignedUrlIcti(row.idAudit)">
          </i>
          }

        </td>

        <!-- ICVI -->
        <td>

          @if (row.preSignedUrlIcvi) {
          <a class="icon-action" (click)="downloadReportAudit(row.preSignedUrlIcvi)">
            <i class="pi pi-download"></i>
          </a>
          }

          @if (!row.preSignedUrlIcvi && isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-download" pTooltip="Arquivo expirado." tooltipPosition="top">
          </i>
          }

          @if (!row.preSignedUrlIcvi && !isOlderFilesDownloads(row.generationDate)) {
          <i class="pi pi-refresh icon-action" pTooltip="Refazer arquivo..." tooltipPosition="top"
            (click)="regeneratepreSignedUrlIcvi(row.idAudit)">
          </i>
          }

        </td>
      </tr>
    </ng-template>
  </p-table>
</div>